import axiosClient from './axiosClient';

const rideSupportChatApi = {
  getConversations: (params) => axiosClient.get('/rides/support-conversations', { params }),
  getConversation: (conversationId) => axiosClient.get(`/rides/support-conversations/${conversationId}`),
  getMessages: (conversationId, params) =>
    axiosClient.get(`/rides/support-conversations/${conversationId}/messages`, { params }),
  sendMessage: (conversationId, text) =>
    axiosClient.post(`/rides/support-conversations/${conversationId}/messages`, { text }),
  markRead: (conversationId) => axiosClient.post(`/rides/support-conversations/${conversationId}/read`),
};

export default rideSupportChatApi;
